import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=2ffb1ed8&"
import script from "./IconClose.vue?vue&type=script&lang=js&"
export * from "./IconClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ffb1ed8')) {
      api.createRecord('2ffb1ed8', component.options)
    } else {
      api.reload('2ffb1ed8', component.options)
    }
    module.hot.accept("./IconClose.vue?vue&type=template&id=2ffb1ed8&", function () {
      api.rerender('2ffb1ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/icons/IconClose.vue"
export default component.exports